export const Permissions = {
    InvoiceDownload  : "invoice-pdf"
}